

(function () {

    angular.module('tmx-app')
        .controller('geoFenceEditCtrl', ['$scope', 'resolvedData', '$state','ToastService','GeofenceService','tmxUtility',
            function GeoFenceEditCtrl($scope, resolvedData, $state, ToastService,GeofenceService,tmxUtility) {
        //Functions/Method
                var geofenceVM=this;                
                var sortOrder = 0;
                geofenceVM.vm = {};
                geofenceVM.geofenceList = [];
                geofenceVM.listGeoFence = [];                
                geofenceVM.addGeofence=addGeofence;
                geofenceVM.removeDetail=removeDetail;
                geofenceVM.setMapValues=setMapValues;
                geofenceVM.getPolygonValues=getPolygonValues;
                geofenceVM.removedGeofence=[];
                geofenceVM.vm.setMapEditable=false;
                geofenceVM.Index=undefined;  
                geofenceVM.geofenceRow = {};
                geofenceVM.geofenceInvalid = "true";
                geofenceVM.date = new Date().toJSON();
                geofenceVM.showStatus = false;
                geofenceVM.readonly = false;
                geofenceVM.isEdit = false;
                geofenceVM.StartDateInvalid = true;
                geofenceVM.EndDateInvalid = true;
                geofenceVM.minDate = geofenceVM.date;
                geofenceVM.maxDate = geofenceVM.date;
                geofenceVM.locations = resolvedData.Locations.data;                                                                                  
                var exists = tmxUtility.exists;

            function addGeofence () {                    
                    let geofenceRow = {
                        GeofenceId: 0,
                        GeofenceName: '',
                        GeofenceCode: '',                                               
                        index: ++sortOrder,
                        EffectiveStartDate:'',
                        EffectiveEndDate:'',
                        LocationId:0,                        
                    };
                    geofenceVM.geofenceList.push(geofenceRow);                    
                }

                function removeDetail(index){                    
                        var result=geofenceVM.geofenceList[index];                        
                           if(result.GeofenceId!='0')
                           {
                                result.GeofenceId=-result.GeofenceId;                            
                               geofenceVM.removedGeofence.push(result);
                           }                                  
                           geofenceVM.geofenceList.splice(index,1);      
                           
                           var count=geofenceVM.geofenceList.length;
                            if(count>1)
                            {
                                geofenceVM.vm.GeofencePoints=[];
                            }
                            else
                            {
                                geofenceVM.vm.GeofencePoints=null;
                            }

                            geofenceVM.geofenceList.forEach(function (element) {                                                                        
                                if(count>1)
                                {
                                    geofenceVM.vm.GeofencePoints.push(element.GeofencePoints);
                                }
                                else
                                {
                                    geofenceVM.vm.GeofencePoints=element.GeofencePoints;
                                }
                            });


                            geofenceVM.result.flag=2;
                            geofenceVM.result.model=geofenceVM.model;
                            geofenceVM.result.value=geofenceVM.vm.GeofencePoints;
                            geofenceVM.result.isEdit=geofenceVM.isEdit;
                }

                function setMapValues(index){                                      
                    geofenceVM.vm.setMapEditable=true;                    
                    geofenceVM.Index=index;                    
                    geofenceVM.vm.GeofencePoints="";  

                }             

                function getPolygonValues(index)
                {   
                    var count=geofenceVM.geofenceList.length;
                    if(count>1)
                    {
                        geofenceVM.vm.GeofencePoints=[];
                    }
                    else
                    {
                        geofenceVM.vm.GeofencePoints=null;
                    }

                    geofenceVM.geofenceList.forEach(function (element) {                                                                        
                        if(count>1)
                        {
                            if(exists(element.GeofencePoints)){
                            geofenceVM.vm.GeofencePoints.push(element.GeofencePoints);
                        }
                        }
                        else
                        {   if(exists(element.GeofencePoints)){
                            geofenceVM.vm.GeofencePoints=element.GeofencePoints;
                        }
                        }
                    });
                    

                    geofenceVM.result.flag=1;
                    geofenceVM.result.model=geofenceVM.geofenceList[index].GeofencePoints;
                    geofenceVM.result.value=geofenceVM.vm.GeofencePoints;
                    geofenceVM.result.isEdit=geofenceVM.isEdit;

                }
                geofenceVM.onStartDateSelected = function(selectedDate) {
                    if(selectedDate != null ) {
                        geofenceVM.vm.EffectiveStartDate = selectedDate.toJSON();//end Date
                    }
                };
                geofenceVM.onEndDateSelected = function(selectedDate) {
                    if(selectedDate != null ) {
                        geofenceVM.vm.EffectiveEndDate = selectedDate.toJSON();//end Date
                    }
                };
                geofenceVM.getFormErrors = function() {
                    if(angular.isDefined(geofenceVM.dialogForm)) {
                        if(geofenceVM.dialogForm.$invalid || geofenceVM.vm.EffectiveEndDate=="Invalid Date" || geofenceVM.geofenceInvalid) {
                            return geofenceVM.dialogForm.$error;
                        }
                    }
                    geofenceVM.formInvalid = false;
                    return undefined;
                }

                geofenceVM.errorChanged = function(newErrors,oldErrors) {
                    if(newErrors!=oldErrors || geofenceVM.vm.EffectiveEndDate=="Invalid Date" || geofenceVM.geofenceInvalid  || geofenceVM.geofenceInvalid) {
                        geofenceVM.dirtyFormControls = [];
                        angular.forEach(geofenceVM.dialogForm, function(value) {
                            if ((typeof value === 'object' && value.hasOwnProperty('$modelValue') && value.$invalid) || (typeof value === 'object' && value.$viewValue=="Invalid Date")) {
                                geofenceVM.dirtyFormControls.push(value.$name);
                            }
                        });
                        
                        if(geofenceVM.dirtyFormControls.length>0){
                        geofenceVM.error_msg = "Required field(s): "
                        for (var i = 0; i < geofenceVM.dirtyFormControls.length; i++) {
                            if(i==geofenceVM.dirtyFormControls.length-1) {
                                geofenceVM.error_msg +=  geofenceVM.dirtyFormControls[i];
                            }
                            else
                                geofenceVM.error_msg +=  geofenceVM.dirtyFormControls[i] + ", ";
                        }
                    }
                    else
                    {
                        geofenceVM.formInvalid = false;
                    }
                    }                                   
                }

                $scope.$watch(geofenceVM.getFormErrors,geofenceVM.errorChanged,true);

                geofenceVM.save = function(action){
                    geofenceVM.formSubmitted = true;    
                    
                    
                      if (geofenceVM.dialogForm.$invalid || geofenceVM.vm.EffectiveEndDate=="Invalid Date" || geofenceVM.geofenceInvalid   || geofenceVM.geofenceInvalid) {
                        geofenceVM.formInvalid = true;
                        geofenceVM.dirtyFormControls = [];
                        angular.forEach(geofenceVM.dialogForm, function(value) {
                            if ((typeof value === 'object' && value.hasOwnProperty('$modelValue') && value.$invalid) || (typeof value === 'object' && value.$viewValue=="Invalid Date")) {
                                value.$setTouched();
                                geofenceVM.dirtyFormControls.push(value.$name);
                            }
                        });

                        if(geofenceVM.dirtyFormControls.length>0){
                        geofenceVM.error_msg = "Required field(s): "
                        for (var i = 0; i < geofenceVM.dirtyFormControls.length; i++) {
                            if(i==geofenceVM.dirtyFormControls.length-1) {
                                geofenceVM.error_msg +=  geofenceVM.dirtyFormControls[i];
                            }
                            else
                                geofenceVM.error_msg +=  geofenceVM.dirtyFormControls[i] + ", ";
                        }                     
                    }
                    else
                    {
                        geofenceVM.formInvalid=false;
                    }
                   
                    }               
                    if(!geofenceVM.formInvalid){
                        geofenceVM.geofenceList.forEach(function (element) {
                            element.LocationId=geofenceVM.vm.LocationId;
                            element.EffectiveStartDate=geofenceVM.vm.EffectiveStartDate;
                            element.EffectiveEndDate=geofenceVM.vm.EffectiveEndDate;
                            element.GeofenceData=null;
                            element.TmxLocation=undefined;
                            // element.GeofencePoint=undefined;
                            
                        });

                        //copy object
                        geofenceVM.listGeoFence=angular.copy(geofenceVM.geofenceList);

                            if(geofenceVM.isEdit)
                            {
                                if(geofenceVM.removedGeofence.length>0)
                                {
                                    geofenceVM.removedGeofence.forEach(function (element) {
                                        element.GeofenceData=null;
                                        element.TmxLocation=undefined;
                                        geofenceVM.listGeoFence.push(element);

                                    });
                                }
                                GeofenceService.getByAction('UpdateList', false, 'put', geofenceVM.listGeoFence).then(function (response) {
                                    if(angular.isDefined(response)){
                                   if(action=="save") {
                                       $state.searchClear = true;
                                       $state.go("^");
                                   }
                                   else if(action=="saveandnew") {
                                       $state.searchClear = true;
                                       $state.reload($state.current);
                                   }
                                   else
                                       ToastService.showCustomToast("error","Some Error Occured");
                                }
                           });  
                            }
                            else
                            {

                            GeofenceService.getByAction('CreateList', false, 'post', geofenceVM.listGeoFence).then(function (response) {
                                 if(angular.isDefined(response)){
                                if(action=="save") {
                                    $state.searchClear = true;
                                    $state.go("^");
                                }
                                else if(action=="saveandnew") {
                                    $state.searchClear = true;
                                    $state.reload($state.current);
                                }
                                else
                                    ToastService.showCustomToast("error","Some Error Occured");
                                }
                        });
                    }
                }
            };

                geofenceVM.cancel = function(){
                    $state.searchClear = true;
                    $state.go("^");
                };

                geofenceVM.getGeofencePoints = function() {                                                                      
                    if(angular.isDefined(geofenceVM.vm.GeofencePoints)) {
                        if(geofenceVM.vm.GeofencePoints!=null &&geofenceVM.vm.GeofencePoints!="") {
                            if(angular.isDefined(geofenceVM.Index)){
                            if(angular.isDefined(geofenceVM.geofenceList[geofenceVM.Index])) {
                                if(geofenceVM.geofenceList[geofenceVM.Index]!=null && geofenceVM.geofenceList[geofenceVM.Index]!="") {
                                    geofenceVM.geofenceList[geofenceVM.Index].GeofencePoints=geofenceVM.vm.GeofencePoints;
                                }
                            }                            
                            geofenceVM.Index=undefined;
                            geofenceVM.vm.GeofencePoints="";                           
                            }
                            return geofenceVM.vm.GeofencePoints;
                        }
                    }
                    return undefined;
                }

                geofenceVM.geofenceChanged = function(newUserId,oldUserId) {
                    if(newUserId!=oldUserId) {
                        geofenceVM.geofenceInvalid = "false";
                    }
                }

                $scope.$watch(geofenceVM.getGeofencePoints,geofenceVM.geofenceChanged);

                (function InitializePage() { 
                    PopulateLookups();           
                    SetFormState();
                })();

                function PopulateLookups(){
                    geofenceVM.gridData = resolvedData.Locations;
                }

                function SetFormState() {
                if($state.data.info==true) {
                    geofenceVM.readonly = true;
                    geofenceVM.StartDateReadonly = true;
                    geofenceVM.EndDateReadonly = true;

                }
                ////////////////////   EDIT//////////
                if(angular.isDefined(resolvedData.GeoFence.data)) {                    
                    geofenceVM.vm = resolvedData.GeoFence.data;
                    geofenceVM.EndDateString = new Date(geofenceVM.vm[0].EffectiveEndDate);
                    geofenceVM.StartDateString = new Date(geofenceVM.vm[0].EffectiveStartDate);
                    geofenceVM.vm.LocationId=geofenceVM.vm[0].LocationId;
                    geofenceVM.vm.EffectiveEndDate=new Date(geofenceVM.vm[0].EffectiveEndDate);
                    geofenceVM.vm.EffectiveStartDate=new Date(geofenceVM.vm[0].EffectiveStartDate);  

                    var count=geofenceVM.vm.length;
                    if(count>1)
                    {
                        geofenceVM.vm.GeofencePoints=[];
                    }

                    geofenceVM.vm.forEach(function (element) {
                        element.index= ++sortOrder;
                        geofenceVM.geofenceList.push(element);

                        if(count>1)
                        {
                            geofenceVM.vm.GeofencePoints.push(element.GeofencePoints);
                        }
                        else
                        {
                            geofenceVM.vm.GeofencePoints=element.GeofencePoints;
                        }
                    });

                    geofenceVM.vm.setMapEditable=true; 
                    geofenceVM.isEdit = true;            
                    if(geofenceVM.vm.EffectiveStartDate<geofenceVM.date) {
                        geofenceVM.StartDateReadonly = true;
                    }
                    else
                        geofenceVM.StartDateReadonly = false;
                }
                ////////////////////   ADD/////////////////
                else {
                    
                    geofenceVM.vm = resolvedData.GeoFence;
                    geofenceVM.StartDateReadonly = false;
                    geofenceVM.EndDateReadonly = false;
                    geofenceVM.vm.EffectiveStartDate = geofenceVM.date;
                    geofenceVM.AddRow=true;


                    if(geofenceVM.AddRow)
                    {
                        addGeofence();
                        geofenceVM.AddRow=false;
                    }
                }

                geofenceVM.result={
                    flag:0,
                    model:'',
                    value:'',
                    isEdit:geofenceVM.isEdit
                };
            }

            }]);
})();

